import React, { useEffect } from "react";
import CustomButton from "../../../../components/custom/CustomButton";
import {
  Layout,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Form,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
const { Content } = Layout;
const { Text } = Typography;

const ViewBranchForm = ({
  parentBranch = [],
  onSubmit,
  tableData = [],

  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchKey,
}) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const currentYear = dayjs().year();

  // Disable future dates and restrict to current year only
  const disabledDate = (current) => {
    return current.year() !== currentYear || current > dayjs().endOf("day");
  };

  // Set default values on mount
  useEffect(() => {
    if (parentBranch.length > 0 && !selectedBranchKey?.id) {
      form.setFieldsValue({
        openedOn: dayjs(), // today
        parentBranch: parentBranch[0].value, // default to first
      });
    }
  }, [parentBranch, selectedBranchKey]);

  useEffect(() => {
    getBranchById(selectedBranchKey.id);
  }, []);

  const getBranchById = (params) => {
    const url = `${apiConfig.OfficeOutlet}/${params + "?template=true"}`;
    const body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const { name, externalId, openingDate, parentId } = res;

        // Convert openingDate array [2009, 1, 1] to dayjs
        const date = Array.isArray(openingDate)
          ? dayjs(new Date(openingDate[0], openingDate[1] - 1, openingDate[2]))
          : dayjs(); // fallback to today if invalid

        // Set form values
        form.setFieldsValue({
          name,
          externalId,
          openedOn: date,
          parentBranch: parentId || (parentBranch[0] && parentBranch[0].value),
        });

        setIsLoading(false);
      }
    });
  };

  return (
    <Form form={form} layout="vertical" style={{ paddingTop: 20 }}>
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Form.Item
                name="name"
                label={<Text strong>Office</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input
                  placeholder="Enter office name"
                  style={{ width: "30vh" }}
                  className="of-bold-disable-input"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="parentBranch"
                label={<Text strong>Parent Branch</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select a parent branch"
                  style={{ width: "30vh" }}
                  options={parentBranch}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="openedOn"
                label={<Text strong>Opened On</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <DatePicker
                  style={{ width: "30vh" }}
                  disabledDate={disabledDate}
                  format="DD MMMM YYYY"
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="externalId"
                label={<Text strong>External ID</Text>}
              >
                <Input
                  placeholder="Enter external ID"
                  style={{ width: "30vh" }}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Card>
    </Form>
  );
};

export default ViewBranchForm;
